/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { Injectable } from '@angular/core';
import { type HttpResponse, type Rest, HttpService } from '@dm/core';
import { type Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DeploymentModeService {
    constructor(
        private http: HttpService,
    ) { }

    /**
     * 查询开局状态
     */
    getDeploymentModeRest(): Rest {
        return this.http.makeUrl('eService.getDeviceMode');
    }

    /**
     * 结束远程开局
     */
    endRemoteDeployment(): Observable<HttpResponse> {
        const rest = this.http.makeUrl('eService.endRemoteDeployment');
        return this.http.post(rest, {}, { doSuccess: true });
    }
}
